module.exports = __webpack_public_path__ + "85a2861a10deb6be8ee8ac2650b2db17.svg";